import { useRef } from 'react'
import styles from './TopFirstView.module.scss'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'
import Button from 'components/common/Button/Button'

const NOTICE_HREF = '/pressrelease/5170/'

const TopFirstView: React.FC = () => {
  const noticeRef = useRef<HTMLDivElement>(null)
  const isNoticeVisible = useElementVisible(noticeRef, 0.1)
  const bannerRef = useRef<HTMLDivElement>(null)
  const isBannerVisible = useElementVisible(bannerRef, 0.1)

  return (
    <section className={styles.topFV}>
      <div
        className={`${styles.topFV__notice} ${animationStyles.fade} ${isNoticeVisible ? animationStyles.fadeOn : ''}`}
        ref={noticeRef}
      >
        <a href={NOTICE_HREF} className={styles.topFV__notice__link} aria-label="社名変更のお知らせを詳しく見る" />
        <div className={styles.topFV__notice__inner}>
          <div className={styles.topFV__notice__content}>
            <div className={styles.topFV__notice__title}>
              <span className={styles.topFV__notice__dot} aria-hidden="true" />
              <span>社名変更のお知らせ</span>
            </div>
            <div className={styles.topFV__notice__detail}>
              <p className={styles.topFV__notice__text}>i3DESIGNからAitriaに変更になります。</p>
              <p className={styles.topFV__notice__date}>（2026/10/21）</p>
            </div>
          </div>
          <div className={styles.topFV__notice__action}>
            <div className={styles.topFV__notice__button}>
              <Button text="詳しく見る" href={NOTICE_HREF} />
            </div>
            <span className={styles.topFV__notice__arrow} aria-hidden="true">
              <img src="/img/common/direction_red.svg" alt="" width={20} height={20} />
            </span>
          </div>
        </div>
      </div>

      <div className={styles.topFV__body}>
        <div
          className={`${styles.topFV__banner} ${animationStyles.fade} ${isBannerVisible ? animationStyles.fadeOn : ''}`}
          ref={bannerRef}
        >
          <a href="/aidd/" target="_blank" className={styles.topFV__banner__link}>
            <figure className={styles.topFV__banner__link__image}>
              <img
                src="/img/common/topbanner_pc.webp"
                alt="AI駆動開発で、組織の競争力を引き上げる。"
                className={styles.pc}
                width={1180}
                height={800}
              />
              <img
                src="/img/common/topbanner_tab.webp"
                alt="AI駆動開発で、組織の競争力を引き上げる。"
                className={styles.tab}
                width={880}
                height={596}
              />
              <img
                src="/img/common/topbanner_sp.webp"
                alt="AI駆動開発で、組織の競争力を引き上げる。"
                className={styles.sp}
                width={375}
                height={255}
              />
            </figure>
          </a>
        </div>
        <h1 className={styles.topFV__title}>
          Design × AI × Engineering で、
          <br className={styles.tab} />
          日本のITを再起動する。
          <br />
          i3DESIGNはAI駆動のデジタルエンジニアリング企業です。
        </h1>
        <p className={styles.topFV__text}>
          AIエージェント、モダンスタック、CI/CD、DevOps、UX/UIをフル活用した開発スタイルで、顧客のモダナイゼーションとAIシフトを実装します。
        </p>
      </div>
    </section>
  )
}

export default TopFirstView
